module.exports = "pegasus_template/assets/social-1-basic-old.png";